export class ListSnapshotRecipeEntriesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entries",
            "baseName": "entries",
            "type": "Array<SnapshotRecipeEntry>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSnapshotRecipeEntriesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
